import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

export const GET_POLICY_NAMES = gql`
  query GetPolicyNames {
    policies {
      name
    }
  }
`;

const useTakenPolicyNames = () => {
  const { data: policyNamesData } = useQuery<{
    policies: Array<{ name: string }>;
  }>(GET_POLICY_NAMES);

  const takenPolicyNames = useMemo(() => {
    return policyNamesData?.policies.map((policy) => policy.name.toLowerCase()) || [];
  }, [policyNamesData]);

  return takenPolicyNames;
};

export default useTakenPolicyNames;
